import { CobaltIconHomeOutline } from '@cae/cobalt-react/icons/outline/CobaltIconHomeOutline';
import { CobaltIconHomeSolid } from '@cae/cobalt-react/icons/solid/CobaltIconHomeSolid';

import type { AppSideNavigationItem } from '../AppSideNavigation.types';

/**
 * Common flow navigation items
 *
 * For users without modules:
 * - Visitor: Just registered, no training yet
 *
 * Each item requires permission check (no exceptions)
 */
export const COMMON_NAV: AppSideNavigationItem[] = [
  {
    label: 'Home',
    path: '/home',
    icon: CobaltIconHomeOutline,
    activeIcon: CobaltIconHomeSolid,
    permission: 'BasicHome_View_Any',
  },
];
